export default "__VITE_ASSET__CPgY12yt__"